import React from 'react'
import { TouchableOpacity, View } from "react-native"
import { useSelector } from 'react-redux'
import Colors from '../../../constants/Colorsv2'
import { Text } from '../../../globalComponents/NativeOverrides'
import { AthleteProps, LeagueProps, TeamProps } from "../../../store/types/sr_svc"

type AthleteLozengeProps = {
    athlete: AthleteProps,
    is_active?:boolean,
    abbr_only?:boolean,
    onSelect: (athlete:AthleteProps) => void
}
export const AthleteLozenge = ({ athlete, is_active, abbr_only, onSelect }:AthleteLozengeProps) => {

    const league:LeagueProps | undefined = useSelector((state:any) => state.event.leagues.find(l => l.league_id == athlete.league_id), (left, right) => left?.league_id == right?.league_id)
    
    const handleSelect = () => {
        if(!onSelect){ return }
        onSelect(athlete)
    }
    
    return (
        <TouchableOpacity style={{ margin:4, borderWidth:1, borderColor:Colors.shades.shade400, backgroundColor:is_active?Colors.brand.midnight:Colors.shades.white, borderRadius:100, padding:10, paddingRight:20, paddingLeft:20 }} onPress={() => handleSelect()}>
            {!abbr_only ?
            <View>
                <Text size={16} color={is_active?Colors.shades.white:Colors.brand.midnight} weight='semibold'>{athlete.position}: {athlete.first_name} {athlete.last_name}</Text>
                {athlete.team ?
                <Text style={{ marginTop:3 }} size={10} color={is_active?Colors.shades.white:Colors.brand.midnight}>{league?`${league.league_name}: `:''}{athlete.team.market_name} {athlete.team.name}</Text>
                :<></>}
            </View>
            :
            <View>
                <Text size={16} color={is_active?Colors.shades.white:Colors.brand.midnight} weight='semibold'>{athlete.abbr_name}</Text>
                {athlete.team ?
                <Text style={{ marginTop:3 }} size={10} color={is_active?Colors.shades.white:Colors.brand.midnight}>{league?`${league.league_name}: `:''}{athlete.team.abbr}</Text>
                :<></>}
            </View>
            }
        </TouchableOpacity>
    )
}

export default AthleteLozenge